import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Address, CityZip, Response} from '../models/models';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private httpClient: HttpClient) { }

  getAddresses(): Observable<Response<Address[]>> {
    return this.httpClient.get<Response<Address[]>>(environment.apiPath + 'Address');
  }

  getAddressByPartnerAid(id: string): Observable<Response<Address>> {
    return this.httpClient.get<Response<Address>>(environment.apiPath + 'Address/' + id + '/PartnerAid');
  }

  getAddressesByCompanies(companies: string): Observable<Response<Address[]>> {
    return this.httpClient.get<Response<Address[]>>(environment.apiPath + 'Address/' + companies + '/Companies');
  }

  getCityZipList(): Observable<Response<CityZip[]>> {
    return this.httpClient.get<Response<CityZip[]>>(environment.apiPath + 'Address/CityZipList');
  }
}
